"use client";
import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { Cinzel_Decorative } from "next/font/google";
import { useForm, FormProvider } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import bgl from "../../../public/background_login_register.png";
import { StorageHelper } from "@/helpers/StorageHelper";
import { jwtDecode } from "jwt-decode";
import { UserService } from "@/services/user.service";

const cinzel = Cinzel_Decorative({
  weight: ["400", "700", "900"],
  preload: false,
});

export default function ForgotPassword() {
  const [step, setStep] = useState("email");
  const [emailSent, setEmailSent] = useState(false);
  const search = useSearchParams();

  const methods = useForm();
  const { handleSubmit, reset } = methods;

  async function onEmail(values: any) {
    reset({"email": ""})
    setEmailSent(true);
    try {      
      const host = window.location.href;
      const href = host?.split("?")[0];
      await UserService.getPassReset(values.email, href);
      StorageHelper.setItem("email", values.email);
      setEmailSent(true);
    } catch (error) {
      console.log(error);
    }
  }

  async function onNewPassword(values: any) {
    try {
      const host = window.location.href;
      const token = search.get("token");
      const href = host?.split("?")[0];
      await UserService.resetPassword({token: href, newPassword: values.password});
      // StorageHelper.setItem("email", values.email);
    } catch (error) {
      console.log(error);
    }
  }

  async function checkToken() {
    const token = search.get("token");
    if (token) {
      const decoded: any = jwtDecode(token);
      const email = await StorageHelper.getItem("email");
      if (!email || !decoded) return;
      if (decoded.email === email) return setStep("password");
    }
  }

  useEffect(() => {
    checkToken();
  }, []);

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{
        backgroundImage: `url(${bgl.src})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Header />
      <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8">
        {step === "email" ? (
          <div className="relative w-full max-w-md p-6 bg-zinc-900 rounded-md shadow-md">
            <div className={cinzel.className}>
              <h5 className="text-center font-bold text-sm text-yellow-500">
                Your email to update your password
              </h5>
            </div>

            <div className="relative mt-4">
              <FormProvider {...methods}>
                <form
                  onSubmit={handleSubmit(onEmail)}
                  className="relative z-10 space-y-4"
                >
                  <FormField
                    name="email"
                    control={methods.control}
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel className="text-white">Email</FormLabel>
                        <FormControl>
                          <Input
                            placeholder="Your email"
                            {...field}
                            className="bg-zinc-500 text-zinc-900"
                          />
                        </FormControl>
                      </FormItem>
                    )}
                  />
                  {
                  emailSent &&
                  <div className="text-green-500">Recovery password email sent. Check your inbox.</div>
                  }
                  <button
                    type="submit"
                    className="w-full mt-4 bg-orange-500 hover:bg-orange-600/90 text-white px-4 py-2 rounded-md"
                  >
                    Send email
                  </button>
                </form>
              </FormProvider>
            </div>
          </div>
        ) : (
          <div className="relative w-full max-w-md p-6 bg-zinc-900 rounded-md shadow-md">
            <div className={cinzel.className}>
              <h5 className="text-center font-bold text-sm text-yellow-500">
                Your new password
              </h5>
            </div>

            <div className="relative mt-4">
              <FormProvider {...methods}>
                <form
                  onSubmit={handleSubmit(onNewPassword)}
                  className="relative z-10 space-y-4"
                >
                  <FormField
                    name="password"
                    control={methods.control}
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel className="text-white">Password</FormLabel>
                        <FormControl>
                          <Input
                            placeholder="Your Password"
                            {...field}
                            className="bg-zinc-500 text-zinc-900"
                            type="password"
                          />
                        </FormControl>
                      </FormItem>
                    )}
                  />

                  <FormField
                    name="repeat-password"
                    control={methods.control}
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel className="text-white">Repeat Password</FormLabel>
                        <FormControl>
                          <Input
                            placeholder="Your Password Again"
                            {...field}
                            className="bg-zinc-500 text-zinc-900"
                            type="password"
                          />
                        </FormControl>
                      </FormItem>
                    )}
                  />

                  <button
                    type="submit"
                    className="w-full mt-4 bg-orange-500 hover:bg-orange-600/90 text-white px-4 py-2 rounded-md"
                  >
                    Change password
                  </button>
                </form>
              </FormProvider>
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}
